import { render } from "./PasswordReset.vue?vue&type=template&id=18ba2f1c&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"

import "./PasswordReset.vue?vue&type=style&index=0&id=18ba2f1c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18ba2f1c"

export default script